import { useState } from "react";
import CustomTabs from "../tabs";
import LoyaltyPoints from "./LoyaltyPoints";
import LoyaltyDashboard from "./loyaltyDashboard";
import { useAccess } from "../../provider/AccessProvider";
import { LOYALTYACCESS } from "../../utils/constant";
import { Alert } from "antd";
import LoyaltyConfig from "./loyaltyConfig";
import { useHotkeys } from "react-hotkeys-hook";
import { useNavigate } from "react-router-dom";
import LoyaltyCoupons from "./loyaltyCoupons";

const Loyalty = () => {
  const [activeKey, setActiveKey] = useState("1");
  const access = useAccess(LOYALTYACCESS);
  const navigate = useNavigate();
  const tabs = [
    {
      key: "1",
      label: "Loyalty Points",
    },
    {
      key: "2",
      label: "Loyalty Reports",
    },
    {
      key: "3",
      label: "Loyalty Configuration",
    },
    {
      key: "4",
      label: "Loyalty Coupons",
    },
  ];
  useHotkeys("alt + a", () => {
    navigate("/dashboard/loyalty");
    setTimeout(() => {
      document.getElementById("viewCustomerBtn")?.click();
    }, 300);
  });

  if (!access.loyalty(false)) {
    return (
      <Alert
        style={{ marginTop: "20px", padding: "20px", textAlign: "center" }}
        message="You don't have access, Please contact your administrator to request the appropriate access."
        type="error"
      />
    );
  }

  return (
    <>
      <CustomTabs
        items={tabs}
        onTabChange={(v) => {
          setActiveKey(v);
        }}
        style={{
          marginBottom: "20px",
        }}
      />
      {activeKey === "1" && <LoyaltyPoints />}
      {activeKey === "2" && (
        <>
          {!access.loyaltyReport(false) ? (
            <Alert
              style={{
                padding: "20px",
                textAlign: "center",
              }}
              message="You don't have access, Please contact your administrator to request the appropriate access."
              type="error"
            />
          ) : (
            <LoyaltyDashboard />
          )}
        </>
      )}
      {activeKey === "3" && <LoyaltyConfig />}
      {activeKey === "4" && <LoyaltyCoupons />}
    </>
  );
};

export default Loyalty;
